import { render, staticRenderFns } from "./BranchWeather.vue?vue&type=template&id=54570466&scoped=true"
import script from "./BranchWeather.vue?vue&type=script&lang=js"
export * from "./BranchWeather.vue?vue&type=script&lang=js"
import style0 from "./BranchWeather.vue?vue&type=style&index=0&id=54570466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54570466",
  null
  
)

export default component.exports